import { useState, useEffect } from "react";
import Tabs from "../tab/Tabs.jsx";
import Loader from "../../utils/Loader";

import LastOrders from "./LastOrders.jsx";
import LastPayments from "./LastPayments";
import CreditorCustomers from "./CreditorCustomers";
import useAxios from "../../services/useAxios";
import { translateToReactSelect } from "../../utils/helperFunction.jsx";

export default function TransactionTab() {
  const [tagOption, setTagOption] = useState([]);
  const { execute: getHashtag } = useAxios("api/Find_tag");
  const [loading, setLoading] = useState(true);
  const [nav, setNav] = useState([
    { title: "آخرین سفارشات", target: "#navs-pills-lastOrders" },
    { title: "مشتریان بستانکار", target: "#navs-pills-creditor" },
    { title: "آخرین پرداخت ها", target: "#navs-pills-lastPayment" }
  ]);
  const [tab, setTab] = useState([]);
  useEffect(() => {
    setTab([
      { id: "navs-pills-lastOrders", component: <LastOrders /> },
      {
        id: "navs-pills-creditor",
        component: <CreditorCustomers tagOption={tagOption} />
      },
      { id: "navs-pills-lastPayment", component: <LastPayments /> }
    ]);
  }, [tagOption]);
  useEffect(() => {
    async function loadpage() {
      await getHashtag().then(result => {
        setTagOption(translateToReactSelect(false, result, "text"));
        setLoading(false);
      });
    }
    loadpage();
  }, []);
  return (
    <>
      <div>
        {loading && <Loader />}
        <Tabs navItem={nav} tabContent={tab} type="horiz"></Tabs>
      </div>
    </>
  );
}
